// extracted by mini-css-extract-plugin
export default {"transitionContainer":"TransitionBlock_transitionContainer__yJXJJ","transitionBlock":"TransitionBlock_transitionBlock__2V5T3"};